import React, { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useLocation,
} from "react-router-dom";
import About from "./screens/About";
import PrivacyPolicy from "./screens/PrivacyPolicy";


// Component to set up routing
const Routing = () => {

  const router = createBrowserRouter([
    {
        path:'/',
        element:<About />
    },
    {
        path:'/privacy-policy',
        element:<PrivacyPolicy />
    }
    // {
    //   path: "/",
    //   element: <Layout />,
    //   children: [
    //     // { index: true, element: role === 'barber' ? <Navigate to="/barber-dashboard" /> : <Welcome /> },
    //     {
    //       index: true,
    //       element: !authToken ? (
    //         <Welcome />
    //       ) : role === "barber" ? (
    //         <Navigate to="/barber-dashboard" />
    //       ) : (
    //         <Welcome />
    //       ),
    //     },
    //     { path: "/signin", element: <Signin /> },
    //     { path: "/signup", element: <Signup /> },
    //     { path: "/create-user-profile", element: <CreateUserProfile /> },
    //     { path: "/privacy-policy", element: <PrivacyPolicy /> },
    //     { path: "/about", element: <About /> },
    //     { path: "/create-barber-profile", element: <CreateBarberProfile /> },
    //     {
    //       path: "/appointment",
    //       element: <ProtectedRoute Component={Appointment} />,
    //     },
    //     { path: "/wallet", element: <ProtectedRoute Component={Wallet} /> },
    //     {
    //       path: "/edit-profile",
    //       element: <ProtectedRoute Component={EditProfile} />,
    //     },
    //     { path: "/security", element: <ProtectedRoute Component={Security} /> },
    //     {
    //       path: "/barber-dashboard",
    //       element: <ProtectedRoute Component={BarberDashboard} />,
    //     },
    //     { path: "/barbers", element: <AllBarbers /> },
    //     { path: "/BarberDetails/:_id", element: <BarberDetails /> },
    //     { path: "/chat", element: <ProtectedRoute Component={Chat} /> },
    //     { path: "/book-appointment", element: <BookAppointment /> },
    //     {
    //       path: "/favourite",
    //       element: <ProtectedRoute Component={Favourite} />,
    //     },
    //     {
    //       path: "/catalouge",
    //       element: <ProtectedRoute Component={Catalouge} />,
    //     },
    //     {
    //       path: "/edit-business-profile",
    //       element: <ProtectedRoute Component={EditBusinessProfile} />,
    //     },
    //   ],
    // },

  ]);

  return <RouterProvider router={router} />;
};

export default Routing;